import script from "./previewActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./previewActivity.vue?vue&type=script&setup=true&lang=js"

import "./previewActivity.vue?vue&type=style&index=0&id=9523b5c4&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9523b5c4"]])

export default __exports__